/**
 * Goth stickers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_stickers`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const gothStickersPack: ToilePack = {
    slug: 'goth-stickers',
    category: 'sticker',
    name: 'Goth stickers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'bat', label: 'Bat', subject: 'a small black bat with wings spread'},
        {key: 'cat', label: 'Cat and moon', subject: 'a black cat sitting in a crescent moon'},
        {key: 'coffin', label: 'Coffin heart', subject: 'a small black coffin with a pink heart on the lid'},
    ],
    styles: [
        {key: 'holo', label: 'Holographic', style: 'holographic sticker, iridescent rainbow sheen across the surface, glossy', palette: 'Iridescent silver shifting through pink, cyan and gold', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'kawaii', label: 'Kawaii', style: 'kawaii sticker illustration, rounded shapes, tiny smiling faces, soft thick outlines', palette: 'Pastel pink, mint, lilac and cream with dark outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'vinyl', label: 'Vinyl', style: 'glossy vinyl sticker, clean vector shapes, bold flat colour, a small highlight', palette: 'Bright flat colour with a white highlight', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
    ],
    directions: ['a spider instead', 'a whole sticker sheet', 'in pastel goth colors'],
    directionHint: 'try: a spider instead',
    seo: {
        title: 'Goth Stickers: Bat, Black Cat, Coffin Heart',
        metaDescription: 'Nine goth aesthetic stickers — a bat, a black cat and moon, a coffin with a heart — in holographic, kawaii, and vinyl styles.',
        h1: 'Goth stickers: bat, black cat and moon, coffin heart',
        tagline: 'Nine stickers, three goth icons, three styles each.',
        intro: 'A small black bat with wings spread, a black cat sitting in a crescent moon, and a small black coffin with a pink heart on the lid — three goth aesthetic stickers, die-cut and ready to print. Each rendered holographic, kawaii, and glossy vinyl. Ask for a spider instead, a graveyard scene, or a candle composition, and the same three styles carry it.',
        useCases: [
            'a laptop or water bottle',
            'a planner or journal page',
            'a phone case sticker sheet',
            'a Halloween or gothic-themed gift',
        ],
        faq: [
            {q: "What's in this pack?", a: 'Nine goth aesthetic stickers — a bat, a black cat and moon, and a coffin heart — in holographic, kawaii, and glossy vinyl finishes.'},
            {q: 'Can I get a spider or a graveyard scene?', a: 'Yes — the direction field takes any variation, including a spider instead, a graveyard scene, or a candle composition.'},
            {q: 'What does the holographic finish print as?', a: 'The holographic design is an illustrated iridescent sheen — print it on holographic vinyl stock for the real shifting effect, or on plain matte stock for a flat colourful version.'},
            {q: 'Is this scary or gory imagery?', a: 'No — these are cute, kawaii-adjacent takes on goth icons, not horror or gore.'},
        ],
    },
}
